<template>
	<div style="background-color: #fafafa;">
		<van-tabs v-model="selected" type="card" color="#1890ff" sticky swipeable @click="switchTab">
			<van-tab title="暖气余额表">
				<van-search class="search-box" shape="round" v-model="value" placeholder="请输入搜索关键词" show-action @search="onSearch(0)" @input="onSearch(0)"
							@cancel="onSearch(0)" @clear="onSearch(0)">
					<div slot="action" style="color: #1890ff;" @click="onPersonalSearch()">自定义</div>
				</van-search>
				<van-pull-refresh v-model="refreshing" @refresh="onRefresh(0)">
					<van-list v-model="loading" :finished="finished" @load="getSkuInventoryList" class="listBox" finished-text="没有更多了">
						<div v-for="(item, index) in list" class="card" :key="item.barcodeIds">
							<table v-if="mainDescriptions.length > 0" class="layout" style="width: 100%;" >
								<tr style="width: 100%;">
									<td colspan="2">
										<div class="header">
										   <span>货品类别：{{item.radCategoryname}}</span>
										</div>
									</td>
								</tr>
								<tr style="width: 100%;">
									<td colspan="2">
										<div class="header">
											<span>{{mainDescriptions[0].fieldShowName}}：{{item.radIdname}}</span>
										</div>
									</td>
								</tr>
								<tr style="width: 100%;" v-for="(desc, i) in mainDescriptions" :key="desc.uuid">
									<td v-if="i>0 && i%2!==0 && desc.inputType===6" style="width: 40%;" class="content"><span>{{desc.fieldShowName}}：</span><span>{{item[desc.fieldName+"name"]}}</span></td>
									<td v-if="i>0 && i%2!==0 && i+1 < mainDescriptions.length && mainDescriptions[i+1].inputType===6" style="width: 50%;" class="content"><span>{{mainDescriptions[i+1].fieldShowName}}：</span><span>{{item[mainDescriptions[i+1].fieldName+"name"]}}</span></td>
									<td v-if="i>0 && i%2!==0 && desc.inputType!==6" style="width: 40%;" class="content"><span>{{desc.fieldShowName}}：</span><span>{{item[desc.fieldName]}}</span></td>
									<td v-if="i>0 && i%2!==0 && i+1 < mainDescriptions.length && mainDescriptions[i+1].inputType!==6" style="width: 50%;" class="content"><span>{{mainDescriptions[i+1].fieldShowName}}：</span><span>{{item[mainDescriptions[i+1].fieldName]}}</span></td>
								</tr>
								<tr style="width: 100%;">
									<td style="width: 40%;" class="content"><span>数量：</span></td>
									<td style="width: 50%;"><span style="font-weight: bold;color:#1890ff;">{{item.quantity}}</span></td>
								</tr>
							</table>
							<table v-if="mainDescriptions.length === 0" class="layout" style="width: 100%;" >
								<tr style="width: 100%;" >
									<td colspan="2">
										<div class="header">
											<span class="title">品牌：{{item.brandName}}</span>
										</div>
									</td>
								</tr>
								<tr style="width: 100%;">
									<td colspan="2" class="content" style="width: 90%;">
										<p><span>系列—型号：</span><span>{{item.categoryName}}—{{item.skuName}}</span></p>
									</td>
								</tr>
								<tr style="width: 100%;" >
									<td style="width: 40%;" class="content"><span>片数：</span><span>{{item.pieces}}</span></td>
									<td style="width: 50%;" class="content"><span>高度分类：</span><span>{{item.centerCategoryname}}</span></td>
								</tr>
								<tr style="width: 100%;" >
									<td style="width: 40%;" class="content"><span>高度：</span><span>{{item.centerSpacing}}</span></td>
									<td style="width: 50%;" class="content"><span>接口口径：</span><span>{{item.calibername}}</span></td>
								</tr>
								<tr style="width: 100%;">
									<td style="width: 40%;" class="content"><span>颜色：</span><span>{{item.colorname}}</span></td>
									<td style="width: 50%;" class="content"><span>进水方式：</span><span>{{item.waterFlowname}}</span></td>
								</tr>
								<tr style="width: 100%;">
									<td colspan="2" class="content"><p><span>特殊定制：</span><span>{{item.isSpecials}}</span></p></td>
								</tr>
								<tr style="width: 100%;">
									<td style="width: 40%;" class="content"><span>数量：</span></td>
									<td style="width: 50%;"><span style="font-weight: bold;color:#1890ff;">{{item.quantity}}</span></td>
								</tr>
								<tr style="width: 100%;">
									<td colspan="2" class="content"><p><span>货架：</span><span>{{item.positionname}}</span></p></td>
								</tr>
							</table>
						</div>
					</van-list>
				</van-pull-refresh>
			</van-tab>
			<van-tab title="配件余额表">
				<van-search class="search-box" shape="round" v-model="value" placeholder="请输入搜索关键词" show-action @search="onSearch(1)" @input="onSearch(1)"
							@cancel="onSearch(1)" @clear="onSearch(1)">
					<div slot="action" style="color: #1890ff;" @click="onSearch(1)">搜索</div>
				</van-search>
				<van-pull-refresh v-model="refreshing" @refresh="onRefresh(1)">
					<van-list v-model="loading" :finished="finished" @load="getPartsInventoryList" class="listBox" finished-text="没有更多了">
						<div v-for="(item, index) in list" class="card" :key="item.skuId">
							<table v-if="partsDescriptions.length > 0" class="layout" style="width: 100%;" >
								<tr style="width: 100%;" >
									<td colspan="2">
										<div class="header">
											<span class="title">品牌：{{item.brandIdname}}</span>
										</div>
									</td>
								</tr>
								<tr v-for="(partsDesc, j) in partsDescriptions" :key="partsDesc.uuid">
									<td style="width: 40%;" class="content"><span>{{partsDesc.fieldShowName}}：</span><span>{{item[partsDesc.fieldName]}}</span></td>
								</tr>
								<tr style="width: 100%;">
									<td colspan="2" style="width: 40%;" class="content"><span>数量：</span><span style="font-weight: bold;color:#1890ff;">{{item.quantity}}</span></td>
								</tr>
							</table>
							<table v-if="partsDescriptions.length === 0" class="layout" style="width: 100%;" >
								<tr style="width: 100%;" >
									<td colspan="2">
										<div class="header">
											<span class="title">品牌：{{item.brandIdname}}</span>
										</div>
									</td>
								</tr>
								<tr style="width: 100%;">
									<td colspan="2" class="content" style="width: 90%;">
										<span>系列：</span><span>{{item.parentName}}</span>
									</td>
								</tr>
								<tr style="width: 100%;" >
									<td colspan="2" style="width: 40%;" class="content"><span>型号：</span><span>{{item.categoryName}}</span></td>
								</tr>
								<tr style="width: 100%;" >
									<td colspan="2" style="width: 40%;" class="content"><span>规格：</span><span>{{item.skuName}}</span></td>
								</tr>
								<tr style="width: 100%;">
									<td colspan="2" style="width: 40%;" class="content"><span>单位：</span><span>{{item.skuUnit}}</span></td>
								</tr>
								<tr style="width: 100%;">
									<td colspan="2" style="width: 40%;" class="content"><span>数量：</span><span style="font-weight: bold;color:#1890ff;">{{item.quantity}}</span></td>
								</tr>
							</table>
						</div>
					</van-list>
				</van-pull-refresh>
			</van-tab>
		</van-tabs>
	</div>
</template>

<script>
	import {Tab, Tabs, Panel, Button, List, Search, Popup, PullRefresh, NavBar, Stepper, Checkbox, CheckboxGroup} from 'vant';
	import dealerOrderService from "../../service/dealerOrderService";
	import {formatDictionary} from "../../utils/dictionary";
	import configService from "../../service/configService";
	import fieldDescriptionService from "../../service/fieldDescriptionService";
	export default {
		data() {
			return {
				selected: 0,
				list: [],
				loading: false,
				finished: false,
				pageIndex: 0,
				refreshing: false,
				value: "",
				data: {},
				type: "main",
				mainDescriptions: [],
				partsDescriptions: []
			};
		},
		components: {
			[Tab.name]: Tab,
			[Tabs.name]: Tabs,
			[Button.name]: Button,
			[PullRefresh.name]: PullRefresh,
			[Panel.name]: Panel,
			[List.name]: List,
			[Search.name]: Search,
			[Popup.name]: Popup,
			[Stepper.name]: Stepper,
			[NavBar.name]: NavBar,
			[Checkbox.name]: Checkbox,
			[CheckboxGroup.name]: CheckboxGroup
		},
		created: async function () {
			this.data.radCategory = this.$route.query.radCategory || "";
			this.data.radId = this.$route.query.radId || "";
			this.data.pieces = this.$route.query.pieces || "";
			this.data.centerCategory = this.$route.query.centerCategory || "";
			this.data.centerSpacing = this.$route.query.centerSpacing || "";
			this.data.caliber = this.$route.query.caliber || "";
			this.data.color = this.$route.query.color || "";
			this.data.waterFlow = this.$route.query.waterFlow || "";
			this.data.isSpecials = this.$route.query.isSpecials || "";
			this.data.custom_text_1 = this.$route.query.custom_text_1 || "";
			this.data.custom_text_2 = this.$route.query.custom_text_2 || "";
			this.data.custom_text_3 = this.$route.query.custom_text_3 || "";
			this.data.custom_text_4 = this.$route.query.custom_text_4 || "";
			this.data.custom_text_4 = this.$route.query.custom_text_4 || "";
			this.data.custom_dropdown_2 = this.$route.query.custom_dropdown_2 || "";
			this.type = this.$route.query.type || "main";
			if(this.type == "main"){
				this.data.skuCategory =  "";
				this.data.skuRadId =  "";
			}else{
				this.data.skuCategory = this.$route.query.radCategory || "";
				this.data.skuRadId = this.$route.query.radId || "";
			}

			let configValue = await configService.getConfigByName("是否配置购物车显示名");
			if (configValue.data.Status === "1"){
				if (configValue.data.Data && configValue.data.Data.value === "是"){
					let mainResp = await fieldDescriptionService.getGridByTableName("rad_order_detail");
					if (mainResp.data.Status === "1" && mainResp.data.Data && mainResp.data.Data.length>0){
						this.mainDescriptions = mainResp.data.Data;
					}
					let partsResp = await fieldDescriptionService.getGridByTableName("psi_transaction_mobile");
					if (partsResp.data.Status === "1" && partsResp.data.Data && partsResp.data.Data.length>0){
						this.partsDescriptions = partsResp.data.Data;
					}
				}
			}
		},
		methods: {
			async getSkuInventoryList() {
				this.pageIndex++;
				let resp = await dealerOrderService.getSkuInventoryList(this.pageIndex, this.value, this.data);
				formatDictionary(resp.data.Data.data, resp.data.Data.dictionary);
				resp.data.Data.data.forEach(item => {
					if(item.isSpecials && item.isSpecials.length > 22){
						let temp = item.isSpecials;
						item.isSpecials = temp.substring(0, 22);
						item.isSpecials += "...";
					}
					if(item.positionname && item.positionname.length > 22){
						let temp = item.positionname;
						item.positionname = temp.substring(0, 22);
						item.positionname += "...";
					}
				});
				this.loading = false;
				this.refreshing = false;
				this.list = [...this.list, ...resp.data.Data.data];
				this.finished = resp.data.Data.total <= this.list.length;
			},
			async getPartsInventoryList() {
				this.pageIndex++;
				let resp = await dealerOrderService.getPartsInventoryList(this.pageIndex, this.value, this.data);
				formatDictionary(resp.data.Data.data, resp.data.Data.dictionary);
				this.loading = false;
				this.refreshing = false;
				this.list = [...this.list, ...resp.data.Data.data];
				this.finished = resp.data.Data.total <= this.list.length;
			},
			onRefresh(index) {
				this.list = [];
				this.finished = false;
				this.loading = true;
				this.pageIndex = 0;
				switch (index) {
					case 0:
						this.getSkuInventoryList();
						break;
					case 1:
						this.getPartsInventoryList();
						break;
					default: break;
				}
			},
			onSearch(index) {
				this.onRefresh(index);
			},
			onPersonalSearch(){
				this.$router.push({path:"searchDetail", query: {type: "main"}});
			},
			switchTab(index) {
				window.scrollTo(0, 0);
				this.value = "";
				this.onRefresh(index)
			},
		}
	}
</script>

<style scoped>
	.psiIndexCont{
	
		width:100%;
		margin:0 auto;
		margin-top:240px;
		margin-bottom:0.24rem;
		overflow: hidden;
	}
	.nav-item{
		margin-top: 2rem;
	}
	.nav-item span{
	  
	}
</style>
